import { Directive, ElementRef, OnInit, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthorizationService } from 'src/app/features-common/services/authorization.service';

@Directive({
  selector: '[authzDisable]'
})
export class DisableIfUnauthorizedDirective implements OnInit {

  //    @Input() authzDisableIfUnauthorized: string


  @Input()
  set authzDisable(value) {
    // console.log("==============In Directive " + value)

    if (this.authorizationService.hasPermission(value)) {
      // console.log("==============In Directive IN TRUE " + value)
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }


  constructor(private element: ElementRef,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef, private authorizationService: AuthorizationService) { }

  ngOnInit() {
    /*
    console.log("==============In Directive "+this.authzDisableIfUnauthorized)

    if (this.authorizationService.hasPermission(this.authzDisableIfUnauthorized)) {
        console.log("==============In Directive IN TRUE ")
        this.viewContainer.createEmbeddedView(this.templateRef);
    }else{
        this.viewContainer.clear();
    }
    */
  }
}
